<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="template-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="tableHeight"
            dialogWidth="80%"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadingEditTemplate="loadingEditTemplate"
            @LoadingTemplateView="LoadingTemplateView"
        >
            <slot slot="filter">
                <el-col :span="4" v-show="region_type == 2">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :span="4" v-show="region_type == 1 && isHavePermissions(`all`)">
                    <item-input type="select" v-model="dic_worker_id" :options="usernameList" :clearable="true" placeholder="请选择所属人"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-select">
                <el-col :span="8" class="padding-right10" style="display: flex; justify-content: space-around; line-height: 100%">
                    <span style="display: inline-block; width: 60%; word-wrap: break-word; white-space: normal; text-align: center">可用范围：</span>
                    <item-input type="radio" v-model="region_type" :options="hasRegionTypePermission"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" v-show="isHavePermissions(`create`)" @click="loadingNewTemplate()" title="">创建<i class="el-icon--right"></i></el-button>
            </slot>
        </crud-facecade>
        <cus-dialog
            class="table-h360"
            :title="collectTemplate.title"
            :visible.sync="collectTemplate.dialogFormVisible"
            :okVisible="collectTemplate.okVisible"
            :close-on-click-modal="false"
            width="60%"
            @confirm="putFormTemplateInfo"
        >
            <cus-form ref="analgesia-info" :data="collectTemplate.data" :columns="TemplateColumnList" @confirm="putTemplateInfo"></cus-form>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnalgesicRecordTemplate`,
    props: {},
    created() {
    },
    data() {
        return {
            title: `镇痛记录模板`,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            dic_worker_id: null,
            usernameList: [],
            region_type: 1,
            hiddenConfirm: true,
            collectTemplate: {
                dialogFormVisible: false,
                title: ``,
                data: {}
            },
            url: {
                baseURL: `api/AcisSystem/AnalgesicRecordTemplate`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadTemplates(resolve, reject)
                    })
                }
            }
        }
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `currentUser`, `enum_region_type`, `active_ward`, `sys_enums`, `screenHeight`, `section_auth`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        hasRegionTypePermission() {
            let r = [{ label: `个人`, value: 1 }]
            if (this.isHavePermissions(`all`) || this.isHavePermissions(`area_edit`) || this.isHavePermissions(`area_read`)) {
                r.push({ label: `区域`, value: 2 })
            }
            return r
        },
        columnList() {
            let me = this
            let username = (this.currentUser && this.currentUser.username) || `--`
            var edittmp = this.isHavePermissions(`all`) || this.isHavePermissions(`area_edit`)
            var deletetmp = this.isHavePermissions(`all`) || this.isHavePermissions(`area_delete`)
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `template_name`,
                    label: `模板名称`,
                    isListable: true,
                    isExpand: false,
                    searchable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    searchable: true,
                    colspan: 6,
                    options: `enum_region_type`
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: me.region_type != 1,
                    colspan: 6,
                    options: this.ward_auth
                },
                {
                    type: `string`,
                    prop: `dic_worker_name`,
                    label: `归属人`,
                    width: `100`,
                    isListable: me.region_type == 1
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `修改人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `modify_date`,
                    label: `修改时间`,
                    width: `140`,
                    isListable: true,
                    sortable: `desc`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `200`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        let btns = []
                        if (username == row.owner && row.region_type == 1 || edittmp) {
                            btns.push({
                                class: `is-plain`,
                                label: `编辑`,
                                icon: ``,
                                type: `primary`,
                                emit: `loadingEditTemplate`,
                                permission: `default`
                            })
                        }
                        if (username == row.owner && row.region_type == 1 || deletetmp) {
                            btns.push({
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `DeleteData`,
                                permission: `default`
                            })
                        }
                        btns.push({
                            class: `is-plain`,
                            label: `查看`,
                            icon: ``,
                            type: `primary`,
                            emit: `LoadingTemplateView`,
                            permission: `default`
                        })
                        return btns
                    }
                }
            ]
        },
        TemplateColumnList() {
            let me = this
            var edittmp = me.isHavePermissions(`all`) || me.isHavePermissions(`area_edit`)
            let list = [
                {
                    type: `string`,
                    prop: `template_name`,
                    label: `模板名称`,
                    colspan: 15,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isExpand: false,
                    colspan: 12,
                    default: edittmp ? 2 : 1,
                    options: edittmp ? me.enum_region_type : _.filter(me.enum_region_type, x => x.label == `个人` || x.value == 1),
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        } else {
                            row.dic_ward_ids = null
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    colspan: 12,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        return row.region_type === 1
                    }
                },
                {
                    type: `multiselect`,
                    prop: `enum_analgesic_modes`,
                    label: `镇痛方式`,
                    colspan: 12,
                    showCount: 2,
                    collapseTags: false,
                    options: this.sys_enums.Enum_AnalgesicMode || [],
                    config: { popperAppendToBody: true },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_analgesia_pump_brand`,
                    label: `镇痛泵品牌`,
                    colspan: 12,
                    options: this.sys_enums.Enum_AnalgesiaPumpBrand || [],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `float`,
                    prop: `total_capacity`,
                    label: this.T(`analgesic_record.total_capacity`),
                    colspan: 12
                },
                {
                    type: `float`,
                    prop: `continuous_dose`,
                    label: this.T(`analgesic_record.continuous_dose`),
                    colspan: 12
                },
                {
                    type: `float`,
                    prop: `single_dose`,
                    label: this.T(`analgesic_record.single_dose`),
                    colspan: 12
                },
                {
                    type: `integer`,
                    prop: `pcatimes`,
                    label: `PCA次数`,
                    colspan: 12
                },
                {
                    type: `float`,
                    prop: `first_dose`,
                    label: this.T(`analgesic_record.first_dose`),
                    colspan: 12
                },
                {
                    type: `float`,
                    prop: `maximum_dose_per_hour`,
                    label: this.T(`analgesic_record.maximum_dose_per_hour`),
                    colspan: 12
                },
                {
                    type: `integer`,
                    prop: `lock_time`,
                    label: this.T(`analgesic_record.lock_time`),
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `recipe_remarks`,
                    label: `配方备注`,
                    colspan: 24
                }
            ]
            return list
        }
    },
    methods: {
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `analgesic_record_temp:${permiskey}`) != -1
        },
        loadTemplates(resolve, reject) {
            let that = this
            if (that.currentUser) {
                let req = that.myaxios.get(`api/AcisSystem/AnalgesicRecordTemplate/Get`)
                req.then((data) => {
                    let allList = _.cloneDeep(data)
                    that.loadOwnerList(allList)
                    if (that.region_type) {
                        data = _.filter(data, d => {
                            return d.region_type == that.region_type
                        })
                    }
                    // 没有全部权限先排除其他人个人模板
                    if (!that.isHavePermissions(`all`)) {
                        data = _.filter(data, d => {
                            return !(d.region_type == 1 && _.find(d.regions, x => { return x.owner != that.currentUser.username }))
                        })
                        // 没有区域编辑和区域查看权限
                        if (!this.isHavePermissions(`area_edit`) && !this.isHavePermissions(`area_read`)) {
                            data = _.filter(data, d => {
                                return d.region_type == 1
                            })
                        }
                    }
                    // 区域
                    if (that.dic_ward_id && that.region_type == 2) {
                        data = _.filter(data, d => {
                            return d.region_type == 2 && _.find(d.regions, { wardstr: that.dic_ward_id })
                        })
                    }
                    // 所属人
                    if (that.dic_worker_id && that.region_type == 1) {
                        data = _.filter(data, d => {
                            return d.region_type == 1 && d.dic_worker_id == that.dic_worker_id
                        })
                    }
                    resolve(data)
                })
            }
        },
        loadOwnerList(data) {
            let that = this
            that.usernameList = []
            let ownerlist = _.filter(data, t => {
                return t.dic_worker_id && t.dic_worker_name
            })
            let ownergroup = ownerlist && _.groupBy(ownerlist, `dic_worker_id`)
            _.forEach(ownergroup, (g) => {
                let r = g[0] && {
                    value: g[0].dic_worker_id,
                    label: g[0].dic_worker_name,
                    jianpin: g[0].dic_worker_abbr
                }
                that.usernameList.push(r)
            })
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`api/AcisSystem/AnalgesicRecordTemplate/Get/${row.id}`)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadingNewTemplate() {
            let that = this
            let rtype = 1
            let wardids = null
            if (that.isHavePermissions(`area_edit`) || that.isHavePermissions(`all`)) {
                rtype = 2
                var ids = []
                ids.push(that.active_ward.value)
                wardids = ids
            }
            that.collectTemplate.data = {
                region_type: rtype,
                dic_ward_ids: wardids
            }
            that.collectTemplate.title = `新增模板`
            that.collectTemplate.dialogFormVisible = true
            that.collectTemplate.okVisible = true
        },
        loadingEditTemplate({ row }) {
            let that = this
            that.collectTemplate.data = {}
            this.loadOne(row)
                .then(data => {
                    that.collectTemplate.data = data
                    that.collectTemplate.title = `修改模板`
                    that.collectTemplate.dialogFormVisible = true
                    that.collectTemplate.okVisible = true
                    console.log(`修改模板`)
                    console.log(that.collectTemplate.data)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        LoadingTemplateView({ row }) {
            let that = this
            that.collectTemplate.data = {}
            this.loadOne(row)
                .then(data => {
                    that.collectTemplate.data = data
                    that.collectTemplate.title = `查看模板`
                    that.collectTemplate.dialogFormVisible = true
                    that.collectTemplate.okVisible = false
                    console.log(`查看模板`)
                    console.log(that.collectTemplate.data)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        putFormTemplateInfo() {
            this.$refs[`analgesia-info`].confirm()
        },
        putTemplateInfo(row) {
            let that = this
            let postData = {
                template_name: row.template_name,
                enum_analgesic_mode: row.enum_analgesic_modes && row.enum_analgesic_modes.join(`,`),
                enum_analgesia_pump_brand: row.enum_analgesia_pump_brand,
                total_capacity: row.total_capacity,
                continuous_dose: row.continuous_dose,
                single_dose: row.single_dose,
                pcatimes: row.pcatimes,
                first_dose: row.first_dose,
                maximum_dose_per_hour: row.maximum_dose_per_hour,
                lock_time: row.lock_time,
                recipe_remarks: row.recipe_remarks,
                regions: row.region_type == 1
                    ? [{ owner: this.currentUser.username }]
                    : row.dic_ward_ids.map(d => {
                        return {
                            sys_analgesic_record_template_id: row.id || 0,
                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    })
            }
            let tp = `post`
            if (row.id && row.id > 0) {
                tp = `put`
                postData.id = row.id
            }
            return new Promise((resolve, reject) => {
                if (row.region_type == 2 && (!row.dic_ward_ids || row.dic_ward_ids == ``)) {
                    this.$message.error(`请选择可用区域！`)
                    return
                }
                let req = this.myaxios[tp](`api/AcisSystem/AnalgesicRecordTemplate/${tp}`, postData)
                req.then(data => {
                    let msg = tp == `post` ? `创建` : `修改`
                    that.$message.success(`${msg}成功`)
                    that.collectTemplate.dialogFormVisible = false
                    that.ReloadListData()
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`template-list`].ReloadListData()
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        },
        dic_worker_id: function() {
            this.ReloadListData()
        },
        region_type: function() {
            this.ReloadListData()
        },
        currentUser: function() {
            this.ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Analgesic/RecordTemplate.vue